module.exports = __webpack_public_path__ + "static/img/visa.8e5a9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/visa.png
// module id = pr8J
// module chunks = 1